// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6278":"e96f3ef6","7320":"3ba40d1f"}[chunkId] + ".chunk.css";
};